import { Config, makeRequest } from "@paywithglide/glide-js";
import { logger } from "../logger";

export type OnrampTransactionStatusRequest = {
  transactionId: string;
  customerId: string;
};

export type OnrampTransactionStatusResponse = {
  status: number;
  code: number;
  data: {
    transactionId: string;
    status: string; // "0", "1", "2", "3", "4", "5", "13", "15", "16", "-1", "-2", "-3", "-4"
    fromAmount: string;
    toAmount: string;
    transactionHash?: string;
  };
};

export async function checkTransactionStatus(
  glideConfig: Config,
  request: OnrampTransactionStatusRequest,
): Promise<OnrampTransactionStatusResponse["data"]> {
  try {
    const response = await makeRequest<OnrampTransactionStatusResponse>(
      glideConfig,
      {
        url: `/onramp/transaction/status`,
        method: "POST",
        body: request,
      },
    );

    if (response.status !== 1 || response.code !== 200) {
      throw new Error(
        `Onramp transaction status API error: status ${response.status}, code ${response.code}`,
      );
    }

    return response.data;
  } catch (error) {
    logger.error(`Failed to check Onramp transaction status: ${error}`);
    throw error;
  }
}

// Helper to check if transaction is complete
export function isTransactionComplete(status: string): boolean {
  return status === "5" || status === "16";
}

// Helper to check if transaction failed
export function isTransactionFailed(status: string): boolean {
  const statusNum = parseInt(status, 10);
  return statusNum < 0;
}

// Get error message for failed status
export function getTransactionErrorMessage(status: string): string {
  switch (status) {
    case "-1":
      return "Transaction timed out. Please try again.";
    case "-2":
      return "Transaction was abandoned.";
    case "-3":
      return "Bank/KYC name mismatch. Please verify your details.";
    case "-4":
      return "Wrong amount sent. Please contact support.";
    default:
      return "Transaction failed. Please try again.";
  }
}
